import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
export const Testimonials: React.FC = () => {
  const testimonials = [{
    name: 'Camila R.',
    headline: 'Por primera vez dejé de sentir que dependía emocionalmente de un mensaje.',
    text: 'Antes revisaba el celular cada 5 minutos. Ahora me siento tranquila. Y lo más loco es que él empezó a buscarme MÁS.',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Valentina M.',
    headline: 'Sentí que esta guía entendía exactamente lo que me pasaba.',
    text: 'No era otro consejo vacío de ‘ámate a ti misma’. Explicaba cosas que literalmente nadie me había dicho.',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Sofía L.',
    headline: 'La dinámica cambió completamente.',
    text: 'Dejé de perseguir sin volverme fría. Y por primera vez sentí que me estaban valorando de verdad.',
    img: 'https://images.unsplash.com/photo-1531123897727-8f129e1bf98c?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="py-20 px-4 bg-brand-rose" data-id="element-226">
      <div className="max-w-6xl mx-auto" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-229">
            Lo Que Mujeres Como Tú Están Diciendo:
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-230">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-lg border border-brand-blush flex flex-col" data-id="element-231">
              <div className="flex text-brand-gold mb-4" data-id="element-232">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-233" />)}
              </div>

              <h4 className="font-serif font-bold text-xl text-brand-charcoal mb-4 leading-snug" data-id="element-234">
                “{t.headline}”
              </h4>

              <p className="text-gray-600 mb-8 flex-1 italic" data-id="element-235">“{t.text}”</p>

              <div className="flex items-center gap-4 pt-6 border-t border-gray-100" data-id="element-236">
                <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-237" />
                <div data-id="element-238">
                  <p className="font-bold text-brand-charcoal" data-id="element-239">{t.name}</p>
                  <p className="text-xs text-emerald-600 flex items-center gap-1 font-medium" data-id="element-240">
                    <ShieldCheck className="w-3 h-3" data-id="element-241" /> Compra Verificada
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};